import { getSegmentWebClient } from 'analytics/segment';

const getAnonymousId = () => {
  const segmentWebClient = getSegmentWebClient();

  if (
    !segmentWebClient ||
    typeof (segmentWebClient || {}).user !== 'function'
  ) {
    return false;
  }

  return segmentWebClient.user().anonymousId();
};

export default getAnonymousId;
